/* eslint-disable */
import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer } from 'react';
import { URL_API_SERVICE } from '../config';

// third-party
import { Chance } from 'chance';
import jwtDecode from 'jwt-decode';

// reducer - state management
import { LOGIN, LOGOUT } from 'store/actions';
import accountReducer from 'store/accountReducer';

// project imports
import Loader from 'ui-component/Loader';
import axios from 'utils/axios';
import { reject } from 'lodash';

import { useDispatch } from 'store';
import { applyUserData } from 'store/slices/user';
import consoleSistema from 'utils/consoleSistema';

const chance = new Chance();

// constant
const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    company: null,
    role: null,
    accessToken: ''
};

const verifyToken = (serviceToken) => {
    if (!serviceToken) {
        return false;
    }
    const decoded = jwtDecode(serviceToken);
    /**
     * Property 'exp' does not exist on type '<T = unknown>(token, options?: JwtDecodeOptions | undefined) => T'.
     */
    return decoded.exp > Date.now() / 1000;
};

const setSession = (serviceToken) => {
    if (serviceToken) {
        localStorage.setItem('serviceToken', serviceToken);
        axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
    } else {
        localStorage.removeItem('serviceToken');
        delete axios.defaults.headers.common.Authorization;
    }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //
const JWTContext = createContext(null);

export const JWTProvider = ({ children }) => {
    const [state, dispatch] = useReducer(accountReducer, initialState);

    const dispatchUser = useDispatch();

    useEffect(()=>{
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    

    useEffect(() => {
        const init = async () => {
            try {
                const serviceToken = window.localStorage.getItem('serviceToken');
                const idCompany = window.localStorage.getItem('id_company');
                if (serviceToken && verifyToken(serviceToken)) {
                    setSession(serviceToken);                    
                    axios.post(` ${URL_API_SERVICE}user/byToken `, {
                        token: serviceToken,
                        id_company: idCompany
                    }).then((response) => {    
                        const { accessToken, user, menu, company, role } = response.data;                        
                        consoleSistema('JWTContext', response,82);
                        setSession(accessToken);
                        dispatch({
                            type: LOGIN,
                            payload: {
                                isLoggedIn: true,
                                user,
                                menu,
                                company,
                                role,
                                accessToken
                            }
                        });
                        const userDataShow = {"photo":"","last_access":""};
                        userDataShow.photo = response.data.user[0].photo;
                        userDataShow.last_access = response.data.user[0].last_access;
                        dispatchUser(applyUserData(userDataShow));
                      })
                      .catch((error) => {  
                        dispatch({
                            type: LOGOUT
                        });    
                        reject(error);
                      });
                } else {
                    dispatch({
                        type: LOGOUT
                    });
                }
            } catch (err) {
                console.error(err);
                dispatch({
                    type: LOGOUT
                });
            }
        };

        init();
    }, []);

    const getToken = (email, password) => new Promise((resolve, reject) => {           
        consoleSistema('JWTContext', 'Viene a obtener token',123);
        axios.post(` ${URL_API_SERVICE}token `, {
            dni: email,
            email,
            secret: password,
            grant_type: 'client_credentials'
        })
          .then((response) => {    
            const { accessToken, user, menu, company, role } = response.data;
            setSession(accessToken);
            dispatch({
                type: LOGIN,
                payload: {
                    isLoggedIn: true,
                    user,
                    menu,
                    company,
                    role,
                    accessToken
                }
            });
            resolve(response) 
          })
          .catch((error) => {  
            reject(error);
          });
    })

    const getTokenAdminCompany = (email, password, idCompany, tokenSeach) => new Promise((resolve, reject) => {   
        consoleSistema('JWTContext', tokenSeach,151);        
        axios.post(` ${URL_API_SERVICE}token `, {
            dni: email,
            email,
            secret: password,
            grant_type: 'client_credentials',
            id_company: idCompany,
            tokenSeach
        })
          .then((response) => {    
            const { accessToken, user, menu, company, role } = response.data;            
            consoleSistema('JWTContext', response.data,162);
            setSession(accessToken);
            localStorage.setItem('id_company', company && company.id_company ? company.id_company : 0);
            dispatch({
                type: LOGIN,
                payload: {
                    isLoggedIn: true,
                    user,
                    menu,
                    company,
                    role,
                    accessToken
                }
            });
            const userDataShow = {"photo":"","last_access":""};
            if (response.data.user && response.data.user[0]) {
                userDataShow.photo = response.data.user[0].photo;
                userDataShow.last_access = response.data.user[0].last_access;
                dispatchUser(applyUserData(userDataShow));
            }

            resolve(response) 
          })
          .catch((error) => {  
            reject(error);
          });
    })

    const login = async (email, password) => {
        axios.post(` ${URL_API_SERVICE}token `, {
            email,
            secret: password,
            grant_type: 'client_credentials'
        }).then(() => {
            const datare={"response":null};   
            reject(datare);

        });        
    };

    const register = async (email, password, firstName, lastName) => {
        // todo: this flow need to be recode as it not verified
        const id = chance.bb_pin();
        const response = await axios.post('/api/account/register', {
            id,
            email,
            password,
            firstName,
            lastName
        });
        let users = response.data;

        if (window.localStorage.getItem('users') !== undefined && window.localStorage.getItem('users') !== null) {
            const localUsers = window.localStorage.getItem('users');
            users = [
                ...JSON.parse(localUsers),
                {
                    id,
                    email,
                    password,
                    name: `${firstName} ${lastName}`
                }
            ];
        }

        window.localStorage.setItem('users', JSON.stringify(users));
    };

    const logout = () => {
        setSession(null);
        localStorage.setItem('id_company', 0);
        dispatch({ type: LOGOUT });
    };

    const resetPassword = (email) => consoleSistema('JWTContext', email,234);

    const updateProfile = () => {};

    if (state.isInitialized !== undefined && !state.isInitialized) {
        return <Loader />;
    }

    return (
        <JWTContext.Provider value={{ ...state, login, logout, register, resetPassword, updateProfile, getToken, getTokenAdminCompany }}>{children}</JWTContext.Provider>
    );
};

JWTProvider.propTypes = {
    children: PropTypes.node
};

export default JWTContext;
